import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIsMobile } from '../../hooks/useIsMobile';
function newLineItem(type) {
    return {
        lineItemId: `li-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
        description: '',
        qty: 1,
        unit: type === 'material' ? 'ea' : 'hr',
        unitPrice: 0,
        type,
    };
}
export const LineItemEditor = ({ lineItems, onChange }) => {
    const isMobile = useIsMobile();
    const addItem = (type) => {
        onChange([...lineItems, newLineItem(type)]);
    };
    const removeItem = (id) => {
        onChange(lineItems.filter((li) => li.lineItemId !== id));
    };
    const updateItem = (id, field, value) => {
        onChange(lineItems.map((li) => li.lineItemId === id ? { ...li, [field]: value } : li));
    };
    const laborTotal = lineItems
        .filter((li) => li.type === 'labor')
        .reduce((sum, li) => sum + li.qty * li.unitPrice, 0);
    const materialTotal = lineItems
        .filter((li) => li.type === 'material')
        .reduce((sum, li) => sum + li.qty * li.unitPrice, 0);
    const grandTotal = laborTotal + materialTotal;
    const inputStyle = {
        padding: '7px 10px',
        fontSize: '14px',
        border: '1px solid rgba(0,0,0,0.1)',
        borderRadius: '8px',
        backgroundColor: 'rgba(255,255,255,0.8)',
        color: '#1d1d1f',
        outline: 'none',
        width: '100%',
        boxSizing: 'border-box',
        minHeight: '36px',
    };
    if (isMobile) {
        return (_jsxs("div", { children: [lineItems.length === 0 && (_jsx("p", { style: { color: '#86868b', fontSize: '14px', textAlign: 'center', padding: '24px 0' }, children: "No line items. Add materials or labor below." })), lineItems.map((li) => (_jsxs("div", { style: {
                        backgroundColor: 'rgba(255,255,255,0.7)',
                        border: '1px solid rgba(0,0,0,0.08)',
                        borderRadius: '12px',
                        padding: '14px',
                        marginBottom: '10px',
                    }, children: [_jsxs("div", { style: {
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '10px',
                            }, children: [_jsx("span", { style: {
                                        display: 'inline-block',
                                        padding: '3px 10px',
                                        backgroundColor: li.type === 'labor'
                                            ? 'rgba(52,199,89,0.12)'
                                            : 'rgba(0,122,255,0.12)',
                                        color: li.type === 'labor' ? '#248a3d' : '#0071e3',
                                        borderRadius: '980px',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                    }, children: li.type === 'labor' ? 'Labor' : 'Material' }), _jsx("button", { onClick: () => removeItem(li.lineItemId), style: {
                                        background: 'none',
                                        border: 'none',
                                        color: '#c0392b',
                                        fontSize: '18px',
                                        cursor: 'pointer',
                                        padding: '4px 8px',
                                        minHeight: '44px',
                                    }, children: "\u00D7" })] }), _jsxs("div", { style: { marginBottom: '8px' }, children: [_jsx("label", { style: { fontSize: '12px', fontWeight: '600', color: '#86868b', display: 'block', marginBottom: '4px' }, children: "Description" }), _jsx("input", { style: inputStyle, type: "text", value: li.description, onChange: (e) => updateItem(li.lineItemId, 'description', e.target.value), placeholder: "Item description" })] }), _jsxs("div", { style: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '8px' }, children: [_jsxs("div", { children: [_jsx("label", { style: { fontSize: '12px', fontWeight: '600', color: '#86868b', display: 'block', marginBottom: '4px' }, children: "Qty" }), _jsx("input", { style: inputStyle, type: "number", min: "0", step: "0.01", value: li.qty, onChange: (e) => updateItem(li.lineItemId, 'qty', parseFloat(e.target.value) || 0) })] }), _jsxs("div", { children: [_jsx("label", { style: { fontSize: '12px', fontWeight: '600', color: '#86868b', display: 'block', marginBottom: '4px' }, children: "Unit" }), _jsx("input", { style: inputStyle, type: "text", value: li.unit, onChange: (e) => updateItem(li.lineItemId, 'unit', e.target.value), placeholder: "ea" })] }), _jsxs("div", { children: [_jsx("label", { style: { fontSize: '12px', fontWeight: '600', color: '#86868b', display: 'block', marginBottom: '4px' }, children: "Unit Price" }), _jsx("input", { style: inputStyle, type: "number", min: "0", step: "0.01", value: li.unitPrice, onChange: (e) => updateItem(li.lineItemId, 'unitPrice', parseFloat(e.target.value) || 0) })] })] }), _jsxs("div", { style: {
                                marginTop: '10px',
                                textAlign: 'right',
                                fontSize: '14px',
                                fontWeight: '600',
                                color: '#1d1d1f',
                            }, children: ["Total: $", (li.qty * li.unitPrice).toFixed(2)] })] }, li.lineItemId))), _jsxs("div", { style: { display: 'flex', gap: '10px', marginBottom: '24px' }, children: [_jsx("button", { onClick: () => addItem('material'), style: {
                                flex: 1,
                                padding: '11px 16px',
                                backgroundColor: 'rgba(0,113,227,0.08)',
                                color: '#0071e3',
                                border: '1px dashed rgba(0,113,227,0.3)',
                                borderRadius: '12px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '600',
                                minHeight: '44px',
                            }, children: "+ Material" }), _jsx("button", { onClick: () => addItem('labor'), style: {
                                flex: 1,
                                padding: '11px 16px',
                                backgroundColor: 'rgba(52,199,89,0.08)',
                                color: '#248a3d',
                                border: '1px dashed rgba(52,199,89,0.3)',
                                borderRadius: '12px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '600',
                                minHeight: '44px',
                            }, children: "+ Labor" })] }), _jsx(TotalsBlock, { laborTotal: laborTotal, materialTotal: materialTotal, grandTotal: grandTotal })] }));
    }
    return (_jsxs("div", { children: [_jsxs("div", { style: {
                    backgroundColor: 'rgba(255,255,255,0.5)',
                    border: '1px solid rgba(255,255,255,0.8)',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    marginBottom: '16px',
                }, children: [_jsx("div", { style: {
                            display: 'grid',
                            gridTemplateColumns: '3fr 1fr 1fr 1.5fr 1fr 1.5fr auto',
                            gap: '8px',
                            padding: '10px 16px',
                            backgroundColor: 'rgba(0,0,0,0.02)',
                            borderBottom: '1px solid rgba(0,0,0,0.08)',
                        }, children: ['Description', 'Qty', 'Unit', 'Unit Price', 'Type', 'Total', ''].map((h) => (_jsx("span", { style: { fontSize: '12px', fontWeight: '600', color: '#86868b' }, children: h }, h))) }), lineItems.length === 0 && (_jsx("p", { style: {
                            textAlign: 'center',
                            color: '#86868b',
                            fontSize: '14px',
                            padding: '32px 24px',
                            margin: 0,
                        }, children: "No line items. Add materials or labor below." })), lineItems.map((li, idx) => (_jsxs("div", { style: {
                            display: 'grid',
                            gridTemplateColumns: '3fr 1fr 1fr 1.5fr 1fr 1.5fr auto',
                            gap: '8px',
                            padding: '10px 16px',
                            alignItems: 'center',
                            borderBottom: idx < lineItems.length - 1 ? '1px solid rgba(0,0,0,0.06)' : 'none',
                        }, children: [_jsx("input", { style: inputStyle, type: "text", value: li.description, onChange: (e) => updateItem(li.lineItemId, 'description', e.target.value), placeholder: "Item description" }), _jsx("input", { style: inputStyle, type: "number", min: "0", step: "0.01", value: li.qty, onChange: (e) => updateItem(li.lineItemId, 'qty', parseFloat(e.target.value) || 0) }), _jsx("input", { style: inputStyle, type: "text", value: li.unit, onChange: (e) => updateItem(li.lineItemId, 'unit', e.target.value), placeholder: "ea" }), _jsx("input", { style: inputStyle, type: "number", min: "0", step: "0.01", value: li.unitPrice, onChange: (e) => updateItem(li.lineItemId, 'unitPrice', parseFloat(e.target.value) || 0) }), _jsx("span", { children: _jsx("span", { style: {
                                        display: 'inline-block',
                                        padding: '3px 8px',
                                        backgroundColor: li.type === 'labor' ? 'rgba(52,199,89,0.12)' : 'rgba(0,122,255,0.12)',
                                        color: li.type === 'labor' ? '#248a3d' : '#0071e3',
                                        borderRadius: '980px',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                    }, children: li.type === 'labor' ? 'Labor' : 'Material' }) }), _jsxs("span", { style: { fontSize: '14px', fontWeight: '600', color: '#1d1d1f' }, children: ["$", (li.qty * li.unitPrice).toFixed(2)] }), _jsx("button", { onClick: () => removeItem(li.lineItemId), style: {
                                    background: 'none',
                                    border: 'none',
                                    color: '#c0392b',
                                    fontSize: '18px',
                                    cursor: 'pointer',
                                    padding: '4px 8px',
                                    lineHeight: 1,
                                }, children: "\u00D7" })] }, li.lineItemId)))] }), _jsxs("div", { style: { display: 'flex', gap: '10px', marginBottom: '24px' }, children: [_jsx("button", { onClick: () => addItem('material'), style: {
                            padding: '10px 20px',
                            backgroundColor: 'rgba(0,113,227,0.08)',
                            color: '#0071e3',
                            border: '1px dashed rgba(0,113,227,0.3)',
                            borderRadius: '12px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '600',
                            minHeight: '40px',
                        }, children: "+ Add Material" }), _jsx("button", { onClick: () => addItem('labor'), style: {
                            padding: '10px 20px',
                            backgroundColor: 'rgba(52,199,89,0.08)',
                            color: '#248a3d',
                            border: '1px dashed rgba(52,199,89,0.3)',
                            borderRadius: '12px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '600',
                            minHeight: '40px',
                        }, children: "+ Add Labor" })] }), _jsx(TotalsBlock, { laborTotal: laborTotal, materialTotal: materialTotal, grandTotal: grandTotal })] }));
};
const TotalsBlock = ({ laborTotal, materialTotal, grandTotal }) => (_jsx("div", { style: {
        backgroundColor: 'rgba(0,0,0,0.02)',
        border: '1px solid rgba(0,0,0,0.08)',
        borderRadius: '12px',
        padding: '16px 20px',
    }, children: _jsxs("div", { style: {
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '40px',
            flexWrap: 'wrap',
        }, children: [_jsxs("div", { style: { textAlign: 'right' }, children: [_jsx("div", { style: { fontSize: '12px', color: '#86868b', marginBottom: '2px' }, children: "Labor Total" }), _jsxs("div", { style: { fontSize: '16px', fontWeight: '600', color: '#248a3d' }, children: ["$", laborTotal.toFixed(2)] })] }), _jsxs("div", { style: { textAlign: 'right' }, children: [_jsx("div", { style: { fontSize: '12px', color: '#86868b', marginBottom: '2px' }, children: "Material Total" }), _jsxs("div", { style: { fontSize: '16px', fontWeight: '600', color: '#0071e3' }, children: ["$", materialTotal.toFixed(2)] })] }), _jsxs("div", { style: { textAlign: 'right' }, children: [_jsx("div", { style: { fontSize: '12px', color: '#86868b', marginBottom: '2px' }, children: "Grand Total" }), _jsxs("div", { style: { fontSize: '20px', fontWeight: '700', color: '#1d1d1f' }, children: ["$", grandTotal.toFixed(2)] })] })] }) }));
//# sourceMappingURL=LineItemEditor.js.map